import css from 'styled-jsx/css';

const styles = css.global`#page-whatsapp {
    display: none;
    background: #FBFBFB;
}

#page-whatsapp.show {
    display: block;
}`;

export default styles;